import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NgxSpinnerService } from 'ngx-spinner';
import { CurriculoDigital } from 'src/app/models/curriculoDigital';
import { CurriculoService } from 'src/app/services/curriculo.service';

@Component({
    selector: 'app-busca-curriculo',
    templateUrl: './busca-curriculo.component.html',
    styleUrls: ['./busca-curriculo.component.scss'],
    standalone: false
})
export class BuscaCurriculoComponent implements OnInit {

  pdf: any;
  downloadLinkXML: SafeResourceUrl;
  downloadLinkRVCE: SafeResourceUrl;

  xmlFile: string;
  codigo: string = '';

  nomeArquivoXML: string = `curriculo_digital_${new Date().getDate() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getFullYear()}.xml`;
  nomeArquivoRVCE: string = `curriculo_digital_${new Date().getDate() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getFullYear()}.pdf`;

  resultadoBusca: any; // CurriculoDigital = null;
  erro: boolean = false;

  dadosDiplomaOpen: boolean[] = [false, false, false];
  opened: number = 0;
  dadosRegistro: any; // DadosRegistro;
  dadosCurso: any; // DadosCurso;
  dadosIES: any; // DadosIes;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private _busca: CurriculoService,
    private domSanitizer: DomSanitizer,
    private spinner: NgxSpinnerService
  ) {
    //this.dadosCurso = new DadosCurso();
    //this.dadosRegistro = new DadosRegistro();
    //this.dadosIES = new DadosIes();
  }

  ngOnInit(): void {
    this.spinner.show();

    this.route.paramMap.subscribe(paramMap => {
      this.codigo = paramMap.get('id');
    });

    this.buscar();
  }

  open(n: number) {
    if (this.dadosDiplomaOpen[n]) {
      this.dadosDiplomaOpen[n] = false;
    } else {
      this.dadosDiplomaOpen = [false, false, false];
      this.dadosDiplomaOpen[n] = true;
    }
  }

  buscar() {
    //const response = this._busca.getCurriculo(this.codigo);

    //// Dados básicos
    //this.resultadoBusca = response;

    ////debugger;

    //// Printa o XML na tela
    //this.pdf = this.getPDF(this.resultadoBusca.Rvce);

    //// Link para download do arquivo XML
    //this.downloadLinkXML = this.domSanitizer.bypassSecurityTrustResourceUrl('data:application/octet-stream;base64,' + this.resultadoBusca.Xml);

    //// Link para download do arquivo PDF
    //this.downloadLinkRVCE = this.domSanitizer.bypassSecurityTrustResourceUrl(this.pdf);


    // TODO: Voltar com a função após implementação do serviço
    this._busca.getCurriculo(this.codigo).subscribe(response => {
      if (response) {
        this.resultadoBusca = response;

        // Printa o XML na tela
        this.pdf = this.getPDF(this.resultadoBusca.rvce);

        // Link para download do arquivo XML
        this.downloadLinkXML = this.domSanitizer.bypassSecurityTrustResourceUrl('data:application/octet-stream;base64,' + this.resultadoBusca.xml);

        // Link para download do arquivo PDF
        this.downloadLinkRVCE = this.domSanitizer.bypassSecurityTrustResourceUrl(this.pdf);
      }

      this.spinner.hide();
    }, error => {
      this.spinner.hide();
      this.erro = true;

      if (error.status === 404) {
        this.resultadoBusca = null;
      } else {
        console.log(error);
      }
    });

    ////this.router.navigate(['/curriculo/' + this.codigo]);

    ////this.spinner.show();

    ////this.isLoading = true;
    ////this.erroDiploma = false;

    ////this._busca.getHistorico(codigo, '').subscribe(response => {
    ////  if (response.length > 0) {
    ////    this.route.navigate(['/hed/' + codigo]);
    ////  } else {
    ////    // Esconde o loader
    ////    this.spinner.hide();
    ////    this.erroDiploma = true;
    ////  }
    ////}, error => {
    ////  // Esconde o loader
    ////  this.spinner.hide();
    ////  this.erroDiploma = true;

    ////  if (error.status === 404) {
    ////    this.diplomaDigital = null;
    ////  } else {
    ////    console.log(error);
    ////  }
    ////});
  }

  //buscar() {
  //  this._busca.getCurriculo(this.codigo).subscribe(response => {
  //    if (response.length > 0) {
  //      this.resultadoBusca = response[0];

  //      // Printa o XML na tela
  //      this.pdf = this.getPDF(this.resultadoBusca.imgRVHE);

  //      // Link para download do arquivo XML
  //      this.downloadLinkXML = this.domSanitizer.bypassSecurityTrustResourceUrl('data:application/octet-stream;base64,' + this.resultadoBusca.codXMLPublico);

  //      // Link para download do arquivo PDF
  //      this.downloadLinkRVCE = this.domSanitizer.bypassSecurityTrustResourceUrl(this.pdf);
  //    } else {
  //      this.erro = true;
  //      this.router.navigate(['/curriculo']);
  //    }

  //    this.spinner.hide();
  //  }, error => {
  //    this.spinner.hide();
  //    this.erro = true;
  //    this.router.navigate(['/curriculo']);

  //    if (error.status === 404) {
  //      this.resultadoBusca = null;
  //    } else {
  //      console.log(error);
  //    }
  //  });
  //}

  getPDF(pdf: string) {
    const byteArray = new Uint8Array(atob(pdf).split('').map(char => char.charCodeAt(0)));
    let blob = new Blob([byteArray], {
      type: 'data:application/pdf'
    });

    return URL.createObjectURL(blob);
  }

}
